import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const heroSection = document.querySelectorAll('.home-hero-section');

    heroSection.forEach(section => {
        const hhSlider = section.querySelectorAll('.hh-slider');

        hhSlider.forEach(slider => {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        });
    });
});